export default __webpack_public_path__ + "static/media/img8.fefe5345.png";